import { Grid, IconButton, ListItem, ListItemSecondaryAction, ListItemText, makeStyles, Theme, Tooltip, Typography } from '@material-ui/core';
import BriefUserInfoDTO from 'dto/BriefUserInfoDTO';
import CancelIcon from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  active: {
    color: theme.palette.primary.main,
    fontWeight: 700
  },
  root: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:nth-child(odd)': {
      background: '#fafafa'
    },
    '&:hover': {
      background: 'rgba(0,0,0,0.04)'
    }
  }
}));

interface AddedRepositoryUserProps {
  user: BriefUserInfoDTO
  added?: boolean
  handleDelete?: (toDelete: BriefUserInfoDTO) => void
  handleUnshare?: (toShare: BriefUserInfoDTO) => void
}


const AddedRepositoryUser = (props: AddedRepositoryUserProps) => {
  const {user, added, handleDelete, handleUnshare} = props;

  const classes = useStyles();

  return <ListItem 
    className={classes.root} 
  >
    <ListItemText>
      <Grid 
        container 
        direction='column'
      >
        <Typography 
          className={added && classes.active || ''} 
          variant='h6'
        >
          {user.firstName} {user.lastName}
        </Typography>
        <Typography variant='caption'>{user.loginID.toLowerCase()}</Typography>
      </Grid>
    </ListItemText>
    <ListItemSecondaryAction>
      <Tooltip
        title={added ? 'Cancel':'Unshare'}
      >
        <IconButton 
          edge='end'
          onClick={() => added ? handleDelete(user):handleUnshare(user)}
          size='small'
        >
          {added ? <CancelIcon fontSize='small'/>:<DeleteIcon fontSize='small' />}
        </IconButton>
      </Tooltip>
    </ListItemSecondaryAction>
  </ListItem>
};

export default AddedRepositoryUser;